import * as z from "zod/v4";

export const duplicateSegmentWithOptions = {
  name: "duplicateSegmentWithOptions" as const,
  input: z.object({
    segmentId: z.string(),
    name: z.string().min(1),
    targetTeamIds: z.array(z.string()).optional(),
  }),
  output: z.object({
    results: z.array(z.object({ teamId: z.string(), segmentId: z.string() })),
  }),
};
